export default "__VITE_ASSET__b4bda576__"